import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';

const OVERRIDE_SETTINGS_DOC = 'config';

const converter = {
  toFirestore(
    config: BonusOverrideSettings.Config,
  ): firebase.firestore.DocumentData {
    return { ...config };
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<BonusOverrideSettings.Config>,
    options: firebase.firestore.SnapshotOptions,
  ): BonusOverrideSettings.Config {
    return {
      ...snapshot.data(options),
    };
  },
};

// Staff-managed override-visibility settings for a driver-bonus program, stored
// as a single doc scoped to the program by path
// (driverBonus/{bonusProgramId}/overrideSettings/config). Controls which
// rewards are hidden while override mode is active.
const getBonusOverrideSettingsRef = ({
  accountId,
  bonusProgramId,
  db,
}: {
  accountId: string;
  bonusProgramId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.DRIVER_BONUS_COLLECTION)
    .doc(bonusProgramId)
    .collection(STORE_CONSTANTS.DRIVER_BONUS_OVERRIDE_SETTINGS_SUBCOLLECTION)
    .doc(OVERRIDE_SETTINGS_DOC)
    .withConverter(converter);
};

export default getBonusOverrideSettingsRef;
